import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { isMobile } from './functions.js';

// Register GSAP plugin
gsap.registerPlugin(ScrollTrigger);

// Footer slide-up animation (mobile only)
function initFooterAnimation() {
    // Only run on mobile
    if (isMobile()) {
        console.log('Footer animation skipped - not desktop');
        return;
    }
    const footer = document.querySelector('.b-site-footer');
    const mainContent = document.querySelector('.b-site-main');

    console.log('Footer element found:', footer);
    console.log('Main content found:', mainContent);

    if (footer && mainContent) {
        // Try multiple selectors to find the last section
        let lastSection = mainContent.querySelector('section:last-of-type');

        const triggerElement = lastSection || mainContent;

        console.log('All sections found:', mainContent.querySelectorAll('section, .brain-section, [class*="b-"]'));
        console.log('Last section found:', lastSection);
        console.log('Using trigger element:', triggerElement);
        console.log('Trigger element class:', triggerElement.className);

        // Add padding to the last section to match footer height
        addFooterPadding(triggerElement, footer);

        gsap.to(footer, {
            y: 0,
            duration: .3,
            ease: "ease-in-out.out",
            scrollTrigger: {
                trigger: triggerElement,
                start: () => {
                    // Calculate the actual content bottom, excluding padding
                    const rect = triggerElement.getBoundingClientRect();
                    const paddingBottom = parseInt(window.getComputedStyle(triggerElement).paddingBottom) || 0;
                    const contentBottom = rect.top + window.scrollY + rect.height - paddingBottom;
                    const viewportBottom = window.scrollY + window.innerHeight;
                    return contentBottom - viewportBottom;
                },
                end: () => {
                    // Make the end point much earlier for reverse scrolling
                    const rect = triggerElement.getBoundingClientRect();
                    const paddingBottom = parseInt(window.getComputedStyle(triggerElement).paddingBottom) || 0;
                    const contentBottom = rect.top + window.scrollY + rect.height - paddingBottom;
                    const viewportBottom = window.scrollY + window.innerHeight;
                    // Extend the active zone by adding extra space (e.g., 600px earlier for quicker response)
                    return (contentBottom - viewportBottom) + 1000;
                },
                toggleActions: "play none none reverse",
                onEnter: () => console.log('Footer animation triggered - sliding up'),
                onLeave: () => console.log('Footer animation reversed - sliding down'),
                onEnterBack: () => console.log('Footer animation re-triggered'),
                onLeaveBack: () => console.log('Footer animation reversed back'),
                markers: false // Remove this after testing
            }
        });
    } else {
        console.warn('Footer or main content not found!');
        console.warn('Footer selector result:', document.querySelector('.b-site-footer'));
        console.warn('Main content selector result:', document.querySelector('.b-site-main'));
        console.warn('All potential main elements:', document.querySelectorAll('#b-site-main, main, .b-site-main'));
    }
}

// Add padding-bottom to last section equal to footer height
function addFooterPadding(element, footer) {
    if (!element || !footer) {
        console.warn('Cannot add footer padding - missing element or footer');
        return;
    }

    // Wait for footer to be rendered, then measure its height
    setTimeout(() => {
        const footerHeight = footer.getBoundingClientRect().height;
        element.style.paddingBottom = `${footerHeight}px`;
        console.log(`Added ${footerHeight}px padding to last section`);

        // Refresh ScrollTrigger to update trigger positions
        ScrollTrigger.refresh();
    }, 100);

    // Update padding on window resize
    window.addEventListener('resize', () => {
        const footerHeight = footer.getBoundingClientRect().height;
        element.style.paddingBottom = `${footerHeight}px`;

        // Refresh ScrollTrigger after resize
        ScrollTrigger.refresh();
    });
}
// initFooterAnimation();

// Page background bottom sticky behavior - JS animated opacity

function initPageBackgroundBottomSticky() {
    const backgroundBottom = document.querySelector('.c-page-background-bottom');

    // Find all onscroll sections
    const onscrollSections = document.querySelectorAll('.b-onscroll');

    if (!backgroundBottom || onscrollSections.length === 0) {
        console.warn('Missing elements for page background sticky:', {
            backgroundBottom: !!backgroundBottom,
            onscrollSectionsFound: onscrollSections.length
        });
        return;
    }

    // Get the first onscroll section
    const firstOnscroll = onscrollSections[0];

    // Position element based on the bottom of the first onscroll section
    const positionElement = () => {

        const sectionRect = firstOnscroll.getBoundingClientRect();
        const sectionHeight = sectionRect.height;
        const sectionTop = sectionRect.top + window.scrollY;
        const sectionBottom = sectionTop + sectionHeight;

        const viewportHeight = window.innerHeight;
        const documentHeight = document.body.scrollHeight;
        const backgroundBottomHeight = backgroundBottom.getBoundingClientRect().height;

        // Position based on section bottom minus the background height (anchored from bottom)
        const backgroundTop = sectionBottom + backgroundBottomHeight;

        console.log('First onscroll section:', firstOnscroll.className);
        console.log('Section height:', sectionHeight);
        console.log('Section top:', sectionTop);
        console.log('Section bottom:', sectionBottom);
        console.log('Background bottom height:', backgroundBottomHeight);
        console.log('Background top position:', backgroundTop);
        console.log('Viewport height:', viewportHeight);
        console.log('Document height:', documentHeight);

        // Reset any inline styles that might interfere
        gsap.set(backgroundBottom, {
            position: 'absolute',
            top: backgroundTop,
            left: 0,
            right: 0,
            height: backgroundBottomHeight,
            opacity: 1,
            clearProps: 'transform' // Clear any previous transforms
        });
    };

    // Initial positioning
    positionElement();

    // Create ScrollTrigger to pin when bottom hits viewport bottom
    ScrollTrigger.create({
        trigger: backgroundBottom,
        start: () => {
            const rect = backgroundBottom.getBoundingClientRect();
            const elementHeight = rect.height;

            // Start pinning when the bottom of the element hits the bottom of viewport
            return `top+=${elementHeight} bottom`;
        },
        end: () => {
            // Pin all the way to the bottom of the document
            const documentHeight = document.body.scrollHeight;
            const viewportHeight = window.innerHeight;
            const maxScroll = documentHeight - viewportHeight;

            console.log('Pin end point (max scroll):', maxScroll);
            return `${maxScroll}px top`;
        },
        pin: true,
        pinSpacing: false,
        onEnter: () => console.log('Background bottom pinned'),
        onLeaveBack: () => console.log('Background bottom unpinned'),
        markers: true // Set to true for debugging
    });

    // Recalculate on resize
    window.addEventListener('resize', () => {
        positionElement();
        ScrollTrigger.refresh();
    });

    console.log('Page background bottom sticky behavior initialized');
}
initPageBackgroundBottomSticky();
